//src/services/coupons.api.js
import { apiRequest } from "./api";

export const getActiveCouponsCount = () =>
  apiRequest("/coupons/count/active");
